module.exports = {"330109001":"城厢街道","330109002":"北干街道","330109003":"蜀山街道","330109004":"新塘街道","330109005":"靖江街道","330109006":"南阳街道","330109007":"义蓬街道","330109008":"河庄街道","330109009":"新湾街道","330109010":"临江街道","330109011":"前进街道","330109012":"闻堰街道","330109013":"宁围街道","330109014":"新街街道","330109100":"楼塔镇","330109101":"河上镇","330109102":"戴村镇","330109103":"浦阳镇","330109104":"进化镇","330109105":"临浦镇","330109106":"义桥镇","330109107":"所前镇","330109108":"衙前镇","330109113":"瓜沥镇","330109115":"益农镇","330109120":"党湾镇","330109401":"萧山经济技术开发区","330109403":"萧山商业城","330109501":"围垦区","330109503":"红山农场","330109505":"萧山钱江世纪城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330109.json
// module id = 871
// module chunks = 0